import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { useContext } from 'react';
import classnames from 'classnames';
import Context from '../../context';
import { getYearsPeriod, getYear, newDate, setYear, isAfter, getStartOfYear, isSameYear, isBefore, setYearOrMonthOfDate } from '../../utils/date-fns';
import useRangeCls from '../../hooks/use-range-cls';
import { getClosingViewDate } from '../../utils';
function Year(props) {
  var context = useContext(Context);
  var prefixCls = context.prefixCls,
    dateValue = context.dateValue,
    viewDate = context.viewDate,
    onDateMouseEnter = context.onDateMouseEnter,
    onDateMouseLeave = context.onDateMouseLeave,
    onSelect = context.onSelect,
    rangeValue = context.rangeValue,
    panelPosition = context.panelPosition,
    hoverRangedValue = context.hoverRangedValue,
    innerPicker = context.innerPicker,
    setInnerPicker = context.setInnerPicker,
    cellRender = context.cellRender,
    range = context.range;
  var yearItemNumber = props.yearItemNumber,
    disabledDate = props.disabledDate,
    _props$picker = props.picker,
    picker = _props$picker === void 0 ? 'date' : _props$picker;
  var _dateValue;
  if (panelPosition) {
    _dateValue = rangeValue;
  } else {
    _dateValue = dateValue;
  }
  var hasFindSelected = false;
  var hasFindToday = false;
  var getYearSelected = function getYearSelected(year) {
    if (hasFindSelected) return false;
    if (Array.isArray(_dateValue)) {
      return _dateValue[0] && getYear(_dateValue[0]) === year || _dateValue[1] && getYear(_dateValue[1]) === year;
    } else {
      if (_dateValue && getYear(_dateValue) === year) {
        hasFindSelected = true;
        return true;
      }
      return false;
    }
  };
  var getYearToday = function getYearToday(year) {
    if (hasFindToday) return false;
    if (year === getYear(newDate())) {
      hasFindToday = true;
      if (Array.isArray(_dateValue)) {
        return _dateValue[0] ? getYear(_dateValue[0]) !== getYear(newDate()) : _dateValue[1] ? getYear(_dateValue[1]) !== getYear(newDate()) : true;
      } else {
        return _dateValue ? getYear(_dateValue) !== year : true;
      }
    }
  };
  function getYearClassNames(y) {
    var _classnames;
    return classnames("".concat(prefixCls, "-year-text"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-year-text-selected"), getYearSelected(y)), _defineProperty(_classnames, "".concat(prefixCls, "-year-text-today"), getYearToday(y)), _classnames));
  }
  var getRangeCls = useRangeCls({
    prefixCls: prefixCls,
    rangeValue: rangeValue,
    hoverRangedValue: hoverRangedValue,
    isRange: !!panelPosition,
    isAfterStart: function isAfterStart(date, rangedValue) {
      return rangedValue[0] ? isAfter(getStartOfYear(date), getStartOfYear(rangedValue[0])) : false;
    },
    isBeforeEnd: function isBeforeEnd(date, rangedValue) {
      return rangedValue[1] ? isBefore(getStartOfYear(date), getStartOfYear(rangedValue[1])) : false;
    },
    isStart: function isStart(date, rangedValue) {
      return rangedValue[0] ? isSameYear(date, rangedValue[0]) : false;
    },
    isEnd: function isEnd(date, rangedValue) {
      return rangedValue[1] ? isSameYear(date, rangedValue[1]) : false;
    }
  });
  var handleClick = function handleClick(date) {
    if (innerPicker === undefined) {
      if (!(disabledDate && disabledDate(date))) {
        onSelect(date, 'mouse');
      }
    } else {
      //
      var _viewDate = viewDate;
      if (panelPosition) {
        _viewDate = getClosingViewDate(viewDate, picker, -1);
      }
      // date = addYears(_viewDate, 1)
      onSelect(setYearOrMonthOfDate(_viewDate, date), 'inner');
      setInnerPicker(undefined);
    }
  };
  function getYearList() {
    var yearsList = [];
    var _getYearsPeriod = getYearsPeriod(viewDate, yearItemNumber),
      startPeriod = _getYearsPeriod.startPeriod,
      endPeriod = _getYearsPeriod.endPeriod;
    var _loop = function _loop() {
      var year = setYear(viewDate, y);
      var _props = {
        onClick: function onClick() {
          return handleClick(year);
        },
        onMouseEnter: function onMouseEnter() {
          if (onDateMouseEnter && !(disabledDate && disabledDate(year))) {
            onDateMouseEnter(year);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (onDateMouseLeave) {
            onDateMouseLeave();
          }
        }
      };
      var originNode = /*#__PURE__*/React.createElement("span", {
        className: getYearClassNames(y)
      }, y);
      yearsList.push( /*#__PURE__*/React.createElement("div", _extends({
        className: classnames("".concat(prefixCls, "-year-item"), _defineProperty({}, "".concat(prefixCls, "-year-item-disabled"), disabledDate && disabledDate(year)), getRangeCls(year)),
        key: y
      }, _props), typeof cellRender === 'function' ? cellRender(y, {
        originNode: originNode,
        panelType: 'year',
        range: range,
        date: year
      }) || originNode : originNode));
    };
    for (var y = startPeriod; y <= endPeriod; y++) {
      _loop();
    }
    return yearsList;
  }
  var yearCls = classnames("".concat(prefixCls, "-year"));
  var yearWarpperCls = classnames("".concat(prefixCls, "-year-warpper"));
  return /*#__PURE__*/React.createElement("div", {
    className: yearCls
  }, /*#__PURE__*/React.createElement("div", {
    className: yearWarpperCls
  }, getYearList()));
}
export default Year;